/* eslint-disable react/forbid-prop-types */
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { isEmpty } from 'lodash';
import VehicleWarrantiesWrapper from 'vdp-used/components/VehicleWarranties/VehicleWarrantiesWrapper.jsx';
import 'vdp-used/components/VehicleWarranties/VehicleWarranties.scss';

class VehicleWarranties extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse: false,
            iconClass: '',
        };
        this.showMore = this.showMore.bind(this);
    }

    showMore() {
        this.setState({
            collapse: !this.state.collapse,
            iconClass: this.state.iconClass !== '' ? '' : 'reverse',
        });
    }

    render() {
        const { warranty } = this.props;
        if (
            isEmpty(warranty) ||
            (!warranty?.supplementaryWarrantyDate && !warranty?.warrantyClass && !warranty?.warrantySupp)
        ) {
            return null;
        }
        const iconDirection = ['icon-chevron-thin-down', this.state.iconClass];

        return (
            <div className="showroom-vdp-used-warranties" onClick={this.showMore}>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <h2 className="sr-subtitle-1 is-centered">{LocaleService.t('VDP_USED.WARRANTY.TITLE')}</h2>
                    <icon className={iconDirection.join(' ')}>&nbsp;</icon>
                    <ReactCollapse isOpened={this.state.collapse}>
                        <VehicleWarrantiesWrapper warranty={warranty} />
                    </ReactCollapse>
                </MediaQuery>
                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                    <h2 className="vdp-information__title is-bold">{LocaleService.t('VDP_USED.WARRANTY.TITLE')}</h2>
                    <VehicleWarrantiesWrapper warranty={this.props.warranty} />
                </MediaQuery>
            </div>
        );
    }
}
VehicleWarranties.propTypes = {
    warranty: PropTypes.shape({
        manufacturers: PropTypes.array.isRequired,
        supplementary: PropTypes.object.isRequired,
        warrantyClass: PropTypes.object.isRequired,
    }).isRequired,
};

VehicleWarranties.displayName = 'VehicleWarranties';

export default VehicleWarranties;
